import { IOfferCard } from '../../../types';

export const isFromSeller = ({ newbuilding }: IOfferCard) => Boolean(newbuilding && newbuilding.isFromSeller);
